import React from 'react'
import * as R from 'ramda'

import { Wrap } from './styles'

import americanExpress from './icons/amex.svg'
import applepay from './icons/apple-pay.svg'
import barclays from './icons/barclays.svg'
import bbva from './icons/bbva.svg'
import bofa from './icons/bofa.svg'
import capital from './icons/capital-one.svg'
import chase from './icons/chase.svg'
import citi from './icons/citi.svg'
import credit from './icons/credit.svg'
import dinersClub from './icons/diners-club.svg'
import diners from './icons/diners-club.svg'
import discover from './icons/discover.svg'
import gpay from './icons/gpay.svg'
import hsbc from './icons/hsbc.svg'
import jcb from './icons/jcb.svg'
import mastercard from './icons/mastercard.svg'
import paypal from './icons/paypal.svg'
import pnc from './icons/pnc.svg'
import sidecar from './icons/sidecar.svg'
import td from './icons/td.svg'
import unionpay from './icons/unionpay.svg'
import usaa from './icons/usaa.svg'
import usbank from './icons/usbank.svg'
import visa from './icons/visa.svg'
import wellsFargo from './icons/wells-fargo.svg'
import defaultBank from './icons/bank.svg'
import defaultCard from './icons/credit.svg'
import paytient from './icons/paytient.svg'

const imageSrcMapping = {
  'american express': americanExpress,
  applepay,
  barclays,
  bbva,
  bofa,
  capital,
  chase,
  citi,
  credit,
  'diners club': dinersClub,
  diners,
  discover,
  gpay,
  hsbc,
  jcb,
  mastercard,
  paypal,
  paytient,
  pnc,
  sidecar,
  td,
  unionpay,
  usaa,
  usbank,
  visa,
  'wells fargo': wellsFargo,
  defaultBank,
  defaultCard,
}

const Component = ({ paymentMethod: { type, brand, bank, issuer } = {} }) => {
  const institutionName = R.toLower((brand ? brand : bank) || '')
  const defaultSrc =
    type === 'BANK_ACCOUNT' || type === 'BANK'
      ? imageSrcMapping.defaultBank
      : imageSrcMapping.defaultCard

  // this step is to allow similar names of financial institutions to work:
  // i.e. PNC Bank and PNC Bank, NA should both be mapped to PNC without having
  // map to find every single permutation
  let iconName = Object.keys(imageSrcMapping).find(k =>
    institutionName.includes(k),
  )

  // There's another icon that we have to consider, but they are not determined from the type/brand
  // Paytient card is by type a credit card, and by brand it is a VISA
  // However, we want to show a different logo that is not VISA
  if (issuer === 'PAYTIENT') {
    iconName = 'paytient'
  }
  return (
    <Wrap data-testid={`info_${type}-${brand || bank}`}>
      <img
        src={imageSrcMapping[iconName] || defaultSrc}
        alt="payment method icon"
      />
    </Wrap>
  )
}

Component.displayName = 'PaymentMethodIcon'

export default Component
